import React, { useState, useEffect } from "react";
import { theme, ConfigProvider, Tabs, Card, Form, Spin } from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import { labelConfig, staticConfig } from "../treasury.config";
import MaturitySettings from "./components/Maturity";
import PricingAndRate from "./components/PricingAndRating";
import { InstrumentParameters } from "./components/InstrumentParameters";
import ProductInformation from "./components/ProductInformation";
import Preview from "./components/Preview";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import TabLabel from "./components/TabLabel";
import Accounting from "./components/Accounting";
import { connect } from "react-redux";
import { useGetProdTemplate } from "./hooks/useServerActions";
import TaxAndCharges from "./components/TaxAndChargesForm";

const AddTreasuryBill = (props) => {
  const navigate = useNavigate();
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/cst0100");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#FBE8FF");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    //
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider>
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
        pageItems={staticConfig.createTreasuryBillBreadcrumbItems}
      >
        <TopContent
          pageTitle={labelConfig.treasuryBill}
          createPageTitle={"Create new product..."}
          // pageItems={staticConfig.createTreasuryBillBreadcrumbItems}
        />
        <MainPage session={session} titleOfPage={"Add Customer"} />
      </MainLayout>
    </ConfigProvider>
  );
};

function MainPage(props) {
  const session = props.session;
  const [activePage, setActivePage] = React.useState(1);
  const [data, setData] = React.useState();
  const { loading, prodTemplate } = useGetProdTemplate(session);
  const [form] = Form.useForm();

  console.log(prodTemplate, "prodTemplate");

  const tabItems = [
    {
      key: "1",
      label: (
        <TabLabel
          number={1}
          label="Product Information"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <ProductInformation
          data={data}
          // form={form}
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "2",
      label: (
        <TabLabel
          number={2}
          label="Instrument Parameter"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <InstrumentParameters
          setData={setData}
          data={data}
          // form={form}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "3",
      label: (
        <TabLabel
          number={3}
          label="Price & Rate Settings"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <PricingAndRate
          setData={setData}
          data={data}
          // form={form}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "4",
      label: (
        <TabLabel
          number={4}
          label="Maturity Settings"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <MaturitySettings
          setData={setData}
          data={data}
          // form={form}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "5",
      label: (
        <TabLabel
          number={5}
          label="Tax & Charges"
          activeTab={activePage}
          setActivePage={setActivePage}
          data={data}
          // form={form}
        />
      ),
      children: (
        <TaxAndCharges
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
          data={data}
          // form={form}
        />
      ),
    },
    {
      key: "6",
      label: (
        <TabLabel
          number={6}
          label="Accounting"
          activeTab={activePage}
          setActivePage={setActivePage}
          data={data}
          // form={form}
        />
      ),
      children: (
        <Accounting
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
          data={data}
          // form={form}
        />
      ),
    },
    {
      key: "7",
      label: (
        <TabLabel number={7} label="Preview" isLast activeTab={activePage} />
      ),
      children: (
        <Preview
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          data={data}
          form={form}
          template={prodTemplate}
        />
      ),
    },
  ];

  return (
    // <div style={{ width: 900, placeSelf: "center", marginTop: 20 }}>
    <div style={{ maxWidth: "500vw", marginInline: 30, marginTop: 20 }}>
      <Spin spinning={loading} size="large">
        <Tabs
          activeKey={String(activePage)}
          items={tabItems}
          tabPosition="left"
          tabBarGutter={0}
          style={{
            minHeight: "723px",
            border: "none",
            marginTop: 20,
          }}
          tabBarStyle={{
            width: "288px",
            borderRight: "none",

            // position: "sticky",
            // top: 30,
          }}
          // NOTE : STYLES ARE UNDER CREATE INTERBANK PLACEMENT
          className="custom-vertical-numbered-tabs"
        />
      </Spin>
    </div>
    // </div>
  );
}

export function SectionCard({ children, style }) {
  return (
    // <Card style={{ padding: 0, borderRadius: 20, maxWidth: 560 }}>
    <Card
      // className="form-section"
      style={{
        padding: 0,
        paddingInline: 30,
        borderRadius: 12,
        maxWidth: 5000,
        ...style,
      }}
    >
      {children}
    </Card>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddTreasuryBill);
